import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import Utilities from '@/Utility/Utilities';
import {ConditionalVisibilityUIListenerParams, OperationEnableUIListenerParams, PropertyClearUIListenerParams} from '#/DefaultViewExtensionInterfaces';

export default class ExchangeConnectionUIListener extends UIListener {

    constructor() {
        super();

        this.createChain(
            this.createPropertyClearUIListener(),
            this.createOperationEnableUIListener(),
            this.createConditionalVisibilityUIListener(),
        );
    }

    private createConditionalVisibilityUIListener(): string | { uiListener: string; params: Object; } {
        const params: ConditionalVisibilityUIListenerParams = {
            rules: [
                {
                    propertieToWatch: 'Version.Value',
                    propertieToToggleVisibility: 'Url',
                    newVisbilityValue: (genericObjectValues) => {
                        const value = genericObjectValues['Version.Value']();
                        return value != 'Microsoft_Graph_API';
                    }
                }
            ]
        }

        return {
            uiListener: 'ConditionalVisibilityUIListener',
            params: params
        }
    }
    
    private createPropertyClearUIListener() {
        const params: PropertyClearUIListenerParams = {
            rules: [
                {
                    propertiesToWatch: ['TenantId', 'ClientId'],
                    propertiesToClear: ['Password']
                }
            ]
        };
        return {
            uiListener: 'PropertyClearUIListener',
            params: params
        };
    }

    private createOperationEnableUIListener() {
        const params: OperationEnableUIListenerParams = {
            rules: [
                {
                    operation: 'CreateTestTask',
                    conditions: [
                        {
                            property: 'TestRecipient',
                            isFulfilled: (value: string) => !Utilities.isNullOrUndefined(value) && Utilities.isNotBlank(value)
                        }
                    ]
                }
            ]
        };
        return {
            uiListener: 'OperationEnableUIListener',
            params: params
        };
    }
}

ComponentManager.setUIListener('ExchangeConnectionUIListener', ExchangeConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.ExchangeConnectionUIListener', ExchangeConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');